import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetScanCriteriaEnabled,
  setScanCriteriaEnabled
} from '../../actions/scan';
import useLocalize from '../../utils/hooks/useLocalize';
import CriteriaCheckbox from './CriteriaCheckbox';
import DotLineMenuIcon from './DotLineMenuIcon';
import PlusRoundedEndsIcon from './PlusRoundedEndsIcon';
import RefineTwoBarsIcon from './RefineTwoBarsIcon';
import RefreshIcon from './RefreshIcon';

// Used for filter option buttons with icon (optional) and text
const FilterOptionButton = ({ icon, text, onClick }) => (
  <div className="filter-option-text" onClick={onClick}>
    {icon}
    {text}
  </div>
);

const ScanCriteriaSection = () => {
  const localize = useLocalize();
  const dispatch = useDispatch();

  // Selector to get scan data from Redux store
  const selectedScan = useSelector((state) => state.scans.selectedScan || null);
  const enabledScanCriteria = useSelector(
    (state) => state.scans.enabledScanCriteria || {}
  );

  useEffect(() => {
    // Default all criteria to enabled whenever a new scan is selected
    if (selectedScan?.id) {
      dispatch(resetScanCriteriaEnabled());
    }
  }, [dispatch, selectedScan?.id]);

  return (
    <div className="scan-criteria-section">
      <div className="scan-criteria-section-inner-left">
        {selectedScan && selectedScan.fields ? (
          <>
            <div className="chip-container">
              {selectedScan.fields?.map((field) => (
                // If a fieldId is missing from the enabled map, treat it as enabled.
                <CriteriaCheckbox
                  key={`${selectedScan.id}--${field.id}`}
                  topText={
                    localize(`desktop.scans.criteria.${field.id}`) || field.id
                  }
                  bottomText={localize('desktop.scans.criteria.all')}
                  isSelected={enabledScanCriteria[field.id] !== false}
                  onClick={() => {
                    const isEnabled = enabledScanCriteria[field.id] !== false;
                    dispatch(setScanCriteriaEnabled(field.id, !isEnabled));
                  }}
                />
              ))}
            </div>
            <div className="chip-menu">
              <FilterOptionButton
                icon={<DotLineMenuIcon />}
                text={localize('desktop.scans.scan.details')}
              />
              <FilterOptionButton
                icon={<PlusRoundedEndsIcon />}
                text={localize('desktop.scans.register.to.my.scans')}
              />
            </div>
          </>
        ) : (
          <div className="scans-construction-message">
            {/* Placeholder when no scan selected TBD */}
            {localize('desktop.scans.criteria.construction')}
          </div>
        )}
      </div>
      <div className="chip-action-area">
        <button className="conditions-settings-button">
          <RefineTwoBarsIcon />
          {localize('desktop.scans.scan.settings')}
        </button>
        <div className="filter-option-menu">
          <FilterOptionButton
            icon={<RefreshIcon />}
            text={localize('desktop.scans.clear.settings')}
            onClick={() => dispatch(resetScanCriteriaEnabled())}
          />
          <FilterOptionButton
            icon={null}
            text={localize('desktop.scans.use.previous.settings')}
          />
        </div>
      </div>
    </div>
  );
};

export default ScanCriteriaSection;
